function S(i, t) {
  if (i == null)
    return {};
  var e = {}, s = Object.keys(i), u, n;
  for (n = 0; n < s.length; n++)
    u = s[n], !(t.indexOf(u) >= 0) && (e[u] = i[u]);
  return e;
}
function d(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new d.InputMask(i, t);
}
class g {
  /** Inserted symbols */
  /** Can skip chars */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  constructor(t) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: !1,
      tailShift: 0
    }, t);
  }
  /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */
  aggregate(t) {
    return this.rawInserted += t.rawInserted, this.skip = this.skip || t.skip, this.inserted += t.inserted, this.tailShift += t.tailShift, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
d.ChangeDetails = g;
function C(i) {
  return typeof i == "string" || i instanceof String;
}
const h = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function L(i) {
  switch (i) {
    case h.LEFT:
      return h.FORCE_LEFT;
    case h.RIGHT:
      return h.FORCE_RIGHT;
    default:
      return i;
  }
}
function w(i) {
  return Array.isArray(i) ? i : [i, new g()];
}
function x(i, t) {
  if (t === i)
    return !0;
  var e = Array.isArray(t), s = Array.isArray(i), u;
  if (e && s) {
    if (t.length != i.length)
      return !1;
    for (u = 0; u < t.length; u++)
      if (!x(t[u], i[u]))
        return !1;
    return !0;
  }
  if (e != s)
    return !1;
  if (t && i && typeof t == "object" && typeof i == "object") {
    var n = t instanceof Date, r = i instanceof Date;
    if (n && r)
      return t.getTime() == i.getTime();
    if (n != r)
      return !1;
    var l = t instanceof RegExp, a = i instanceof RegExp;
    if (l && a)
      return t.toString() == i.toString();
    if (l != a)
      return !1;
    var o = Object.keys(t);
    for (u = 0; u < o.length; u++)
      if (!Object.prototype.hasOwnProperty.call(i, o[u]))
        return !1;
    for (u = 0; u < o.length; u++)
      if (!x(i[o[u]], t[o[u]]))
        return !1;
    return !0;
  } else if (t && i && typeof t == "function" && typeof i == "function")
    return t.toString() === i.toString();
  return !1;
}
class N {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(t, e, s, u) {
    for (this.value = t, this.cursorPos = e, this.oldValue = s, this.oldSelection = u; this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
  }
  /**
    Start changing position
    @readonly
  */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /**
    Inserted symbols count
    @readonly
  */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /**
    Inserted symbols
    @readonly
  */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /**
    Removed symbols count
    @readonly
  */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /**
    Removed symbols
    @readonly
  */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /**
    Unchanged head symbols
    @readonly
  */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /**
    Unchanged tail symbols
    @readonly
  */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /**
    Remove direction
    @readonly
  */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? h.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? h.RIGHT : h.LEFT;
  }
}
class f {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = arguments.length > 2 ? arguments[2] : void 0;
    this.value = t, this.from = e, this.stop = s;
  }
  toString() {
    return this.value;
  }
  extend(t) {
    this.value += String(t);
  }
  appendTo(t) {
    return t.append(this.toString(), {
      tail: !0
    }).aggregate(t._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  unshift(t) {
    if (!this.value.length || t != null && this.from >= t)
      return "";
    const e = this.value[0];
    return this.value = this.value.slice(1), e;
  }
  shift() {
    if (!this.value.length)
      return "";
    const t = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), t;
  }
}
class p {
  // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773
  /** @type {Mask} */
  /** */
  // $FlowFixMe no ideas
  /** Transforms value before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing in the end of editing */
  /** Format typed value to string */
  /** Parse strgin to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(t) {
    this._value = "", this._update(Object.assign({}, p.DEFAULTS, t)), this.isInitialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(t) {
    Object.keys(t).length && this.withValueRefresh(this._update.bind(this, t));
  }
  /**
    Sets new options
    @protected
  */
  _update(t) {
    Object.assign(this, t);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value
    };
  }
  set state(t) {
    this._value = t._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  /** */
  get value() {
    return this._value;
  }
  set value(t) {
    this.resolve(t);
  }
  /** Resolve new value */
  resolve(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      input: !0
    };
    return this.reset(), this.append(t, e, ""), this.doCommit(), this.value;
  }
  /** */
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(t) {
    this.reset(), this.append(t, {}, ""), this.doCommit();
  }
  /** */
  get typedValue() {
    return this.doParse(this.value);
  }
  set typedValue(t) {
    this.value = this.doFormat(t);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.value.length, {
      raw: !0
    });
  }
  set rawInputValue(t) {
    this.reset(), this.append(t, {
      raw: !0
    }, ""), this.doCommit();
  }
  get displayValue() {
    return this.value;
  }
  /** */
  get isComplete() {
    return !0;
  }
  /** */
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(t, e) {
    return t;
  }
  totalInputPositions() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return Math.min(this.value.length, e - t);
  }
  /** Extracts value in range considering flags */
  extractInput() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(t, e);
  }
  /** Extracts tail in range */
  extractTail() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return new f(this.extractInput(t, e), t);
  }
  /** Appends tail */
  // $FlowFixMe no ideas
  appendTail(t) {
    return C(t) && (t = new f(String(t))), t.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(t) {
    return t ? (this._value += t, new g({
      inserted: t,
      rawInserted: t
    })) : new g();
  }
  /** Appends char */
  _appendChar(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 ? arguments[2] : void 0;
    const u = this.state;
    let n;
    if ([t, n] = w(this.doPrepare(t, e)), n = n.aggregate(this._appendCharRaw(t, e)), n.inserted) {
      let r, l = this.doValidate(e) !== !1;
      if (l && s != null) {
        const a = this.state;
        this.overwrite === !0 && (r = s.state, s.unshift(this.value.length - n.tailShift));
        let o = this.appendTail(s);
        l = o.rawInserted === s.toString(), !(l && o.inserted) && this.overwrite === "shift" && (this.state = a, r = s.state, s.shift(), o = this.appendTail(s), l = o.rawInserted === s.toString()), l && o.inserted && (this.state = a);
      }
      l || (n = new g(), this.state = u, s && r && (s.state = r));
    }
    return n;
  }
  /** Appends optional placeholder at end */
  _appendPlaceholder() {
    return new g();
  }
  /** Appends optional eager placeholder at end */
  _appendEager() {
    return new g();
  }
  /** Appends symbols considering flags */
  // $FlowFixMe no ideas
  append(t, e, s) {
    if (!C(t))
      throw new Error("value should be string");
    const u = new g(), n = C(s) ? new f(String(s)) : s;
    e != null && e.tail && (e._beforeTailState = this.state);
    for (let r = 0; r < t.length; ++r) {
      const l = this._appendChar(t[r], e, n);
      if (!l.rawInserted && !this.doSkipInvalid(t[r], e, n))
        break;
      u.aggregate(l);
    }
    return (this.eager === !0 || this.eager === "append") && e !== null && e !== void 0 && e.input && t && u.aggregate(this._appendEager()), n != null && (u.tailShift += this.appendTail(n).tailShift), u;
  }
  /** */
  remove() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this._value = this.value.slice(0, t) + this.value.slice(e), new g();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(t) {
    if (this._refreshing || !this.isInitialized)
      return t();
    this._refreshing = !0;
    const e = this.rawInputValue, s = this.value, u = t();
    return this.rawInputValue = e, this.value && this.value !== s && s.indexOf(this.value) === 0 && this.append(s.slice(this.value.length), {}, ""), delete this._refreshing, u;
  }
  /** */
  runIsolated(t) {
    if (this._isolated || !this.isInitialized)
      return t(this);
    this._isolated = !0;
    const e = this.state, s = t(this);
    return this.state = e, delete this._isolated, s;
  }
  /** */
  doSkipInvalid(t) {
    return this.skipInvalid;
  }
  /**
    Prepares string before mask processing
    @protected
  */
  doPrepare(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.prepare ? this.prepare(t, this, e) : t;
  }
  /**
    Validates if value is acceptable
    @protected
  */
  doValidate(t) {
    return (!this.validate || this.validate(this.value, this, t)) && (!this.parent || this.parent.doValidate(t));
  }
  /**
    Does additional processing in the end of editing
    @protected
  */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  /** */
  doFormat(t) {
    return this.format ? this.format(t, this) : t;
  }
  /** */
  doParse(t) {
    return this.parse ? this.parse(t, this) : t;
  }
  /** */
  splice(t, e, s, u) {
    let n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      input: !0
    };
    const r = t + e, l = this.extractTail(r), a = this.eager === !0 || this.eager === "remove";
    let o;
    a && (u = L(u), o = this.extractInput(0, r, {
      raw: !0
    }));
    let m = t;
    const A = new g();
    if (u !== h.NONE && (m = this.nearestInputPos(t, e > 1 && t !== 0 && !a ? h.NONE : u), A.tailShift = m - t), A.aggregate(this.remove(m)), a && u !== h.NONE && o === this.rawInputValue)
      if (u === h.FORCE_LEFT) {
        let D;
        for (; o === this.rawInputValue && (D = this.value.length); )
          A.aggregate(new g({
            tailShift: -1
          })).aggregate(this.remove(D - 1));
      } else
        u === h.FORCE_RIGHT && l.unshift();
    return A.aggregate(this.append(s, n, l));
  }
  maskEquals(t) {
    return this.mask === t;
  }
  typedValueEquals(t) {
    const e = this.typedValue;
    return t === e || p.EMPTY_VALUES.includes(t) && p.EMPTY_VALUES.includes(e) || this.doFormat(t) === this.doFormat(this.typedValue);
  }
}
p.DEFAULTS = {
  format: String,
  parse: (i) => i,
  skipInvalid: !0
};
p.EMPTY_VALUES = [void 0, null, ""];
d.Masked = p;
function T(i) {
  if (i == null)
    throw new Error("mask property should be defined");
  return i instanceof RegExp ? d.MaskedRegExp : C(i) ? d.MaskedPattern : i instanceof Date || i === Date ? d.MaskedDate : i instanceof Number || typeof i == "number" || i === Number ? d.MaskedNumber : Array.isArray(i) || i === Array ? d.MaskedDynamic : d.Masked && i.prototype instanceof d.Masked ? i : i instanceof d.Masked ? i.constructor : i instanceof Function ? d.MaskedFunction : (console.warn("Mask not found for mask", i), d.Masked);
}
function B(i) {
  if (d.Masked && i instanceof d.Masked)
    return i;
  i = Object.assign({}, i);
  const t = i.mask;
  if (d.Masked && t instanceof d.Masked)
    return t;
  const e = T(t);
  if (!e)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new e(i);
}
d.createMask = B;
const M = ["parent", "isOptional", "placeholderChar", "displayChar", "lazy", "eager"], j = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class O {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    const {
      parent: e,
      isOptional: s,
      placeholderChar: u,
      displayChar: n,
      lazy: r,
      eager: l
    } = t, a = S(t, M);
    this.masked = B(a), Object.assign(this, {
      parent: e,
      isOptional: s,
      placeholderChar: u,
      displayChar: n,
      lazy: r,
      eager: l
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return t === 0 && e >= 1 ? (this.isFilled = !1, this.masked.remove(t, e)) : new g();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.isFilled)
      return new g();
    const s = this.masked.state, u = this.masked._appendChar(t, e);
    return u.inserted && this.doValidate(e) === !1 && (u.inserted = u.rawInserted = "", this.masked.state = s), !u.inserted && !this.isOptional && !this.lazy && !e.input && (u.inserted = this.placeholderChar), u.skip = !u.inserted && !this.isOptional, this.isFilled = !!u.inserted, u;
  }
  append() {
    return this.masked.append(...arguments);
  }
  _appendPlaceholder() {
    const t = new g();
    return this.isFilled || this.isOptional || (this.isFilled = !0, t.inserted = this.placeholderChar), t;
  }
  _appendEager() {
    return new g();
  }
  extractTail() {
    return this.masked.extractTail(...arguments);
  }
  appendTail() {
    return this.masked.appendTail(...arguments);
  }
  extractInput() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 ? arguments[2] : void 0;
    return this.masked.extractInput(t, e, s);
  }
  nearestInputPos(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    const s = 0, u = this.value.length, n = Math.min(Math.max(t, s), u);
    switch (e) {
      case h.LEFT:
      case h.FORCE_LEFT:
        return this.isComplete ? n : s;
      case h.RIGHT:
      case h.FORCE_RIGHT:
        return this.isComplete ? n : u;
      case h.NONE:
      default:
        return n;
    }
  }
  totalInputPositions() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(t, e).length;
  }
  doValidate() {
    return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(t) {
    this.masked.state = t.masked, this.isFilled = t.isFilled;
  }
}
class R {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    Object.assign(this, t), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._value = this._value.slice(0, t) + this._value.slice(e), this._value || (this._isRawInput = !1), new g();
  }
  nearestInputPos(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    const s = 0, u = this._value.length;
    switch (e) {
      case h.LEFT:
      case h.FORCE_LEFT:
        return s;
      case h.NONE:
      case h.RIGHT:
      case h.FORCE_RIGHT:
      default:
        return u;
    }
  }
  totalInputPositions() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._isRawInput ? e - t : 0;
  }
  extractInput() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).raw && this._isRawInput && this._value.slice(t, e) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = new g();
    if (this.isFilled)
      return s;
    const u = this.eager === !0 || this.eager === "append", r = this.char === t && (this.isUnmasking || e.input || e.raw) && (!e.raw || !u) && !e.tail;
    return r && (s.rawInserted = this.char), this._value = s.inserted = this.char, this._isRawInput = r && (e.raw || e.input), s;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const t = new g();
    return this.isFilled || (this._value = t.inserted = this.char), t;
  }
  extractTail() {
    return arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, new f("");
  }
  // $FlowFixMe no ideas
  appendTail(t) {
    return C(t) && (t = new f(String(t))), t.appendTo(this);
  }
  append(t, e, s) {
    const u = this._appendChar(t[0], e);
    return s != null && (u.tailShift += this.appendTail(s).tailShift), u;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _isRawInput: this._isRawInput
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
}
const H = ["chunks"];
class k {
  /** */
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.chunks = t, this.from = e;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  // $FlowFixMe no ideas
  extend(t) {
    if (!String(t))
      return;
    C(t) && (t = new f(String(t)));
    const e = this.chunks[this.chunks.length - 1], s = e && // if stops are same or tail has no stop
    (e.stop === t.stop || t.stop == null) && // if tail chunk goes just after last chunk
    t.from === e.from + e.toString().length;
    if (t instanceof f)
      s ? e.extend(t.toString()) : this.chunks.push(t);
    else if (t instanceof k) {
      if (t.stop == null) {
        let u;
        for (; t.chunks.length && t.chunks[0].stop == null; )
          u = t.chunks.shift(), u.from += t.from, this.extend(u);
      }
      t.toString() && (t.stop = t.blockIndex, this.chunks.push(t));
    }
  }
  appendTo(t) {
    if (!(t instanceof d.MaskedPattern))
      return new f(this.toString()).appendTo(t);
    const e = new g();
    for (let s = 0; s < this.chunks.length && !e.skip; ++s) {
      const u = this.chunks[s], n = t._mapPosToBlock(t.value.length), r = u.stop;
      let l;
      if (r != null && // if block not found or stop is behind lastBlock
      (!n || n.index <= r)) {
        if (u instanceof k || // for continuous block also check if stop is exist
        t._stops.indexOf(r) >= 0) {
          const a = t._appendPlaceholder(r);
          e.aggregate(a);
        }
        l = u instanceof k && t._blocks[r];
      }
      if (l) {
        const a = l.appendTail(u);
        a.skip = !1, e.aggregate(a), t._value += a.inserted;
        const o = u.toString().slice(a.rawInserted.length);
        o && e.aggregate(t.append(o, {
          tail: !0
        }));
      } else
        e.aggregate(t.append(u.toString(), {
          tail: !0
        }));
    }
    return e;
  }
  get state() {
    return {
      chunks: this.chunks.map((t) => t.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(t) {
    const {
      chunks: e
    } = t, s = S(t, H);
    Object.assign(this, s), this.chunks = e.map((u) => {
      const n = "chunks" in u ? new k() : new f();
      return n.state = u, n;
    });
  }
  unshift(t) {
    if (!this.chunks.length || t != null && this.from >= t)
      return "";
    const e = t != null ? t - this.from : t;
    let s = 0;
    for (; s < this.chunks.length; ) {
      const u = this.chunks[s], n = u.unshift(e);
      if (u.toString()) {
        if (!n)
          break;
        ++s;
      } else
        this.chunks.splice(s, 1);
      if (n)
        return n;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let t = this.chunks.length - 1;
    for (; 0 <= t; ) {
      const e = this.chunks[t], s = e.shift();
      if (e.toString()) {
        if (!s)
          break;
        --t;
      } else
        this.chunks.splice(t, 1);
      if (s)
        return s;
    }
    return "";
  }
}
class U {
  constructor(t, e) {
    this.masked = t, this._log = [];
    const {
      offset: s,
      index: u
    } = t._mapPosToBlock(e) || (e < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = s, this.index = u, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const t = this._log.pop();
    return this.state = t, t;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.value.length));
  }
  _pushLeft(t) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((e = this.block) === null || e === void 0 ? void 0 : e.value.length) || 0) {
      var e;
      if (t())
        return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(t) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (t())
        return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, h.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, h.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, h.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, h.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, h.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, h.NONE), !0;
    });
  }
}
class G extends p {
  /**
    @override
    @param {Object} opts
  */
  _update(t) {
    t.mask && (t.validate = (e) => e.search(t.mask) >= 0), super._update(t);
  }
}
d.MaskedRegExp = G;
const z = ["_blocks"];
class c extends p {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.definitions = Object.assign({}, j, t.definitions), super(Object.assign({}, c.DEFAULTS, t));
  }
  /**
    @override
    @param {Object} opts
  */
  _update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.definitions = Object.assign({}, this.definitions, t.definitions), super._update(t), this._rebuildMask();
  }
  /** */
  _rebuildMask() {
    const t = this.definitions;
    this._blocks = [], this._stops = [], this._maskedBlocks = {};
    let e = this.mask;
    if (!e || !t)
      return;
    let s = !1, u = !1;
    for (let l = 0; l < e.length; ++l) {
      var n, r;
      if (this.blocks) {
        const D = e.slice(l), I = Object.keys(this.blocks).filter((E) => D.indexOf(E) === 0);
        I.sort((E, V) => V.length - E.length);
        const F = I[0];
        if (F) {
          const E = B(Object.assign({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite
          }, this.blocks[F]));
          E && (this._blocks.push(E), this._maskedBlocks[F] || (this._maskedBlocks[F] = []), this._maskedBlocks[F].push(this._blocks.length - 1)), l += F.length - 1;
          continue;
        }
      }
      let a = e[l], o = a in t;
      if (a === c.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (a === "{" || a === "}") {
        s = !s;
        continue;
      }
      if (a === "[" || a === "]") {
        u = !u;
        continue;
      }
      if (a === c.ESCAPE_CHAR) {
        if (++l, a = e[l], !a)
          break;
        o = !1;
      }
      const m = (n = t[a]) !== null && n !== void 0 && n.mask && !(((r = t[a]) === null || r === void 0 ? void 0 : r.mask.prototype) instanceof d.Masked) ? t[a] : {
        mask: t[a]
      }, A = o ? new O(Object.assign({
        parent: this,
        isOptional: u,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar
      }, m)) : new R({
        char: a,
        eager: this.eager,
        isUnmasking: s
      });
      this._blocks.push(A);
    }
  }
  /**
    @override
  */
  get state() {
    return Object.assign({}, super.state, {
      _blocks: this._blocks.map((t) => t.state)
    });
  }
  set state(t) {
    const {
      _blocks: e
    } = t, s = S(t, z);
    this._blocks.forEach((u, n) => u.state = e[n]), super.state = s;
  }
  /**
    @override
  */
  reset() {
    super.reset(), this._blocks.forEach((t) => t.reset());
  }
  /**
    @override
  */
  get isComplete() {
    return this._blocks.every((t) => t.isComplete);
  }
  /**
    @override
  */
  get isFilled() {
    return this._blocks.every((t) => t.isFilled);
  }
  get isFixed() {
    return this._blocks.every((t) => t.isFixed);
  }
  get isOptional() {
    return this._blocks.every((t) => t.isOptional);
  }
  /**
    @override
  */
  doCommit() {
    this._blocks.forEach((t) => t.doCommit()), super.doCommit();
  }
  /**
    @override
  */
  get unmaskedValue() {
    return this._blocks.reduce((t, e) => t += e.unmaskedValue, "");
  }
  set unmaskedValue(t) {
    super.unmaskedValue = t;
  }
  /**
    @override
  */
  get value() {
    return this._blocks.reduce((t, e) => t += e.value, "");
  }
  set value(t) {
    super.value = t;
  }
  get displayValue() {
    return this._blocks.reduce((t, e) => t += e.displayValue, "");
  }
  /**
    @override
  */
  appendTail(t) {
    return super.appendTail(t).aggregate(this._appendPlaceholder());
  }
  /**
    @override
  */
  _appendEager() {
    var t;
    const e = new g();
    let s = (t = this._mapPosToBlock(this.value.length)) === null || t === void 0 ? void 0 : t.index;
    if (s == null)
      return e;
    this._blocks[s].isFilled && ++s;
    for (let u = s; u < this._blocks.length; ++u) {
      const n = this._blocks[u]._appendEager();
      if (!n.inserted)
        break;
      e.aggregate(n);
    }
    return e;
  }
  /**
    @override
  */
  _appendCharRaw(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this._mapPosToBlock(this.value.length), u = new g();
    if (!s)
      return u;
    for (let l = s.index; ; ++l) {
      var n, r;
      const a = this._blocks[l];
      if (!a)
        break;
      const o = a._appendChar(t, Object.assign({}, e, {
        _beforeTailState: (n = e._beforeTailState) === null || n === void 0 || (r = n._blocks) === null || r === void 0 ? void 0 : r[l]
      })), m = o.skip;
      if (u.aggregate(o), m || o.rawInserted)
        break;
    }
    return u;
  }
  /**
    @override
  */
  extractTail() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const s = new k();
    return t === e || this._forEachBlocksInRange(t, e, (u, n, r, l) => {
      const a = u.extractTail(r, l);
      a.stop = this._findStopBefore(n), a.from = this._blockStartPos(n), a instanceof k && (a.blockIndex = n), s.extend(a);
    }), s;
  }
  /**
    @override
  */
  extractInput() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (t === e)
      return "";
    let u = "";
    return this._forEachBlocksInRange(t, e, (n, r, l, a) => {
      u += n.extractInput(l, a, s);
    }), u;
  }
  _findStopBefore(t) {
    let e;
    for (let s = 0; s < this._stops.length; ++s) {
      const u = this._stops[s];
      if (u <= t)
        e = u;
      else
        break;
    }
    return e;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(t) {
    const e = new g();
    if (this.lazy && t == null)
      return e;
    const s = this._mapPosToBlock(this.value.length);
    if (!s)
      return e;
    const u = s.index, n = t != null ? t : this._blocks.length;
    return this._blocks.slice(u, n).forEach((r) => {
      if (!r.lazy || t != null) {
        const l = r._blocks != null ? [r._blocks.length] : [], a = r._appendPlaceholder(...l);
        this._value += a.inserted, e.aggregate(a);
      }
    }), e;
  }
  /** Finds block in pos */
  _mapPosToBlock(t) {
    let e = "";
    for (let s = 0; s < this._blocks.length; ++s) {
      const u = this._blocks[s], n = e.length;
      if (e += u.value, t <= e.length)
        return {
          index: s,
          offset: t - n
        };
    }
  }
  /** */
  _blockStartPos(t) {
    return this._blocks.slice(0, t).reduce((e, s) => e += s.value.length, 0);
  }
  /** */
  _forEachBlocksInRange(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = arguments.length > 2 ? arguments[2] : void 0;
    const u = this._mapPosToBlock(t);
    if (u) {
      const n = this._mapPosToBlock(e), r = n && u.index === n.index, l = u.offset, a = n && r ? n.offset : this._blocks[u.index].value.length;
      if (s(this._blocks[u.index], u.index, l, a), n && !r) {
        for (let o = u.index + 1; o < n.index; ++o)
          s(this._blocks[o], o, 0, this._blocks[o].value.length);
        s(this._blocks[n.index], n.index, 0, n.offset);
      }
    }
  }
  /**
    @override
  */
  remove() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const s = super.remove(t, e);
    return this._forEachBlocksInRange(t, e, (u, n, r, l) => {
      s.aggregate(u.remove(r, l));
    }), s;
  }
  /**
    @override
  */
  nearestInputPos(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.NONE;
    if (!this._blocks.length)
      return 0;
    const s = new U(this, t);
    if (e === h.NONE)
      return s.pushRightBeforeInput() || (s.popState(), s.pushLeftBeforeInput()) ? s.pos : this.value.length;
    if (e === h.LEFT || e === h.FORCE_LEFT) {
      if (e === h.LEFT) {
        if (s.pushRightBeforeFilled(), s.ok && s.pos === t)
          return t;
        s.popState();
      }
      if (s.pushLeftBeforeInput(), s.pushLeftBeforeRequired(), s.pushLeftBeforeFilled(), e === h.LEFT) {
        if (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.ok && s.pos <= t || (s.popState(), s.ok && s.pos <= t))
          return s.pos;
        s.popState();
      }
      return s.ok ? s.pos : e === h.FORCE_LEFT ? 0 : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : 0);
    }
    return e === h.RIGHT || e === h.FORCE_RIGHT ? (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.pushRightBeforeFilled() ? s.pos : e === h.FORCE_RIGHT ? this.value.length : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : this.nearestInputPos(t, h.LEFT))) : t;
  }
  /**
    @override
  */
  totalInputPositions() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = 0;
    return this._forEachBlocksInRange(t, e, (u, n, r, l) => {
      s += u.totalInputPositions(r, l);
    }), s;
  }
  /** Get block by name */
  maskedBlock(t) {
    return this.maskedBlocks(t)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(t) {
    const e = this._maskedBlocks[t];
    return e ? e.map((s) => this._blocks[s]) : [];
  }
}
c.DEFAULTS = {
  lazy: !0,
  placeholderChar: "_"
};
c.STOP_CHAR = "`";
c.ESCAPE_CHAR = "\\";
c.InputDefinition = O;
c.FixedDefinition = R;
d.MaskedPattern = c;
class b extends c {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  /** */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  /**
    @override
  */
  _update(t) {
    t = Object.assign({
      to: this.to || 0,
      from: this.from || 0,
      maxLength: this.maxLength || 0
    }, t);
    let e = String(t.to).length;
    t.maxLength != null && (e = Math.max(e, t.maxLength)), t.maxLength = e;
    const s = String(t.from).padStart(e, "0"), u = String(t.to).padStart(e, "0");
    let n = 0;
    for (; n < u.length && u[n] === s[n]; )
      ++n;
    t.mask = u.slice(0, n).replace(/0/g, "\\0") + "0".repeat(e - n), super._update(t);
  }
  /**
    @override
  */
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(t) {
    let e = "", s = "";
    const [, u, n] = t.match(/^(\D*)(\d*)(\D*)/) || [];
    return n && (e = "0".repeat(u.length) + n, s = "9".repeat(u.length) + n), e = e.padEnd(this.maxLength, "0"), s = s.padEnd(this.maxLength, "9"), [e, s];
  }
  // TODO str is a single char everytime
  /**
    @override
  */
  doPrepare(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s;
    if ([t, s] = w(super.doPrepare(t.replace(/\D/g, ""), e)), !this.autofix || !t)
      return t;
    const u = String(this.from).padStart(this.maxLength, "0"), n = String(this.to).padStart(this.maxLength, "0");
    let r = this.value + t;
    if (r.length > this.maxLength)
      return "";
    const [l, a] = this.boundaries(r);
    return Number(a) < this.from ? u[r.length - 1] : Number(l) > this.to ? this.autofix === "pad" && r.length < this.maxLength ? ["", s.aggregate(this.append(u[r.length - 1] + t, e))] : n[r.length - 1] : t;
  }
  /**
    @override
  */
  doValidate() {
    const t = this.value;
    if (t.search(/[^0]/) === -1 && t.length <= this._matchFrom)
      return !0;
    const [s, u] = this.boundaries(t);
    return this.from <= Number(u) && Number(s) <= this.to && super.doValidate(...arguments);
  }
}
d.MaskedRange = b;
class _ extends c {
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** */
  /**
    @param {Object} opts
  */
  constructor(t) {
    super(Object.assign({}, _.DEFAULTS, t));
  }
  /**
    @override
  */
  _update(t) {
    t.mask === Date && delete t.mask, t.pattern && (t.mask = t.pattern);
    const e = t.blocks;
    t.blocks = Object.assign({}, _.GET_DEFAULT_BLOCKS()), t.min && (t.blocks.Y.from = t.min.getFullYear()), t.max && (t.blocks.Y.to = t.max.getFullYear()), t.min && t.max && t.blocks.Y.from === t.blocks.Y.to && (t.blocks.m.from = t.min.getMonth() + 1, t.blocks.m.to = t.max.getMonth() + 1, t.blocks.m.from === t.blocks.m.to && (t.blocks.d.from = t.min.getDate(), t.blocks.d.to = t.max.getDate())), Object.assign(t.blocks, this.blocks, e), Object.keys(t.blocks).forEach((s) => {
      const u = t.blocks[s];
      !("autofix" in u) && "autofix" in t && (u.autofix = t.autofix);
    }), super._update(t);
  }
  /**
    @override
  */
  doValidate() {
    const t = this.date;
    return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && t != null && (this.min == null || this.min <= t) && (this.max == null || t <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(t) {
    return this.format(this.parse(t, this), this).indexOf(t) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(t) {
    this.typedValue = t;
  }
  /**
    @override
  */
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(t) {
    super.typedValue = t;
  }
  /**
    @override
  */
  maskEquals(t) {
    return t === Date || super.maskEquals(t);
  }
}
_.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: (i) => {
    if (!i)
      return "";
    const t = String(i.getDate()).padStart(2, "0"), e = String(i.getMonth() + 1).padStart(2, "0"), s = i.getFullYear();
    return [t, e, s].join(".");
  },
  parse: (i) => {
    const [t, e, s] = i.split(".");
    return new Date(s, e - 1, t);
  }
};
_.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: b,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: b,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: b,
    from: 1900,
    to: 9999
  }
});
d.MaskedDate = _;
class P {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let t;
    try {
      t = this._unsafeSelectionStart;
    } catch {
    }
    return t != null ? t : this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let t;
    try {
      t = this._unsafeSelectionEnd;
    } catch {
    }
    return t != null ? t : this.value.length;
  }
  /** Safely sets element selection */
  select(t, e) {
    if (!(t == null || e == null || t === this.selectionStart && e === this.selectionEnd))
      try {
        this._unsafeSelect(t, e);
      } catch {
      }
  }
  /** Should be overriden in subclasses */
  _unsafeSelect(t, e) {
  }
  /** Should be overriden in subclasses */
  get isActive() {
    return !1;
  }
  /** Should be overriden in subclasses */
  bindEvents(t) {
  }
  /** Should be overriden in subclasses */
  unbindEvents() {
  }
}
d.MaskElement = P;
class v extends P {
  /** Mapping between HTMLElement events and mask internal events */
  /** HTMLElement to use mask on */
  /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */
  constructor(t) {
    super(), this.input = t, this._handlers = {};
  }
  /** */
  // $FlowFixMe https://github.com/facebook/flow/issues/2839
  get rootElement() {
    var t, e, s;
    return (t = (e = (s = this.input).getRootNode) === null || e === void 0 ? void 0 : e.call(s)) !== null && t !== void 0 ? t : document;
  }
  /**
    Is element in focus
    @readonly
  */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    return this.input.selectionStart;
  }
  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(t, e) {
    this.input.setSelectionRange(t, e);
  }
  /**
    HTMLElement value
    @override
  */
  get value() {
    return this.input.value;
  }
  set value(t) {
    this.input.value = t;
  }
  /**
    Binds HTMLElement events to mask internal events
    @override
  */
  bindEvents(t) {
    Object.keys(t).forEach((e) => this._toggleEventHandler(v.EVENTS_MAP[e], t[e]));
  }
  /**
    Unbinds HTMLElement events to mask internal events
    @override
  */
  unbindEvents() {
    Object.keys(this._handlers).forEach((t) => this._toggleEventHandler(t));
  }
  /** */
  _toggleEventHandler(t, e) {
    this._handlers[t] && (this.input.removeEventListener(t, this._handlers[t]), delete this._handlers[t]), e && (this.input.addEventListener(t, e), this._handlers[t] = e);
  }
}
v.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
d.HTMLMaskElement = v;
class y extends v {
  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    const t = this.rootElement, e = t.getSelection && t.getSelection(), s = e && e.anchorOffset, u = e && e.focusOffset;
    return u == null || s == null || s < u ? s : u;
  }
  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    const t = this.rootElement, e = t.getSelection && t.getSelection(), s = e && e.anchorOffset, u = e && e.focusOffset;
    return u == null || s == null || s > u ? s : u;
  }
  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(t, e) {
    if (!this.rootElement.createRange)
      return;
    const s = this.rootElement.createRange();
    s.setStart(this.input.firstChild || this.input, t), s.setEnd(this.input.lastChild || this.input, e);
    const u = this.rootElement, n = u.getSelection && u.getSelection();
    n && (n.removeAllRanges(), n.addRange(s));
  }
  /**
    HTMLElement value
    @override
  */
  get value() {
    return this.input.textContent;
  }
  set value(t) {
    this.input.textContent = t;
  }
}
d.HTMLContenteditableMaskElement = y;
const q = ["mask"];
class Y {
  /**
    View element
    @readonly
  */
  /**
    Internal {@link Masked} model
    @readonly
  */
  /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */
  constructor(t, e) {
    this.el = t instanceof P ? t : t.isContentEditable && t.tagName !== "INPUT" && t.tagName !== "TEXTAREA" ? new y(t) : new v(t), this.masked = B(e), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  /** Read or update mask */
  get mask() {
    return this.masked.mask;
  }
  maskEquals(t) {
    var e;
    return t == null || ((e = this.masked) === null || e === void 0 ? void 0 : e.maskEquals(t));
  }
  set mask(t) {
    if (this.maskEquals(t))
      return;
    if (!(t instanceof d.Masked) && this.masked.constructor === T(t)) {
      this.masked.updateOptions({
        mask: t
      });
      return;
    }
    const e = B({
      mask: t
    });
    e.unmaskedValue = this.masked.unmaskedValue, this.masked = e;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(t) {
    this.value !== t && (this.masked.value = t, this.updateControl(), this.alignCursor());
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(t) {
    this.unmaskedValue !== t && (this.masked.unmaskedValue = t, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(t) {
    this.masked.typedValueEquals(t) || (this.masked.typedValue = t, this.updateControl(), this.alignCursor());
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /**
    Starts listening to element events
    @protected
  */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }
  /**
    Stops listening to element events
    @protected
   */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /**
    Fires custom event
    @protected
   */
  _fireEvent(t) {
    for (var e = arguments.length, s = new Array(e > 1 ? e - 1 : 0), u = 1; u < e; u++)
      s[u - 1] = arguments[u];
    const n = this._listeners[t];
    n && n.forEach((r) => r(...s));
  }
  /**
    Current selection start
    @readonly
  */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(t) {
    !this.el || !this.el.isActive || (this.el.select(t, t), this._saveSelection());
  }
  /**
    Stores current selection
    @protected
  */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl() {
    const t = this.masked.unmaskedValue, e = this.masked.value, s = this.displayValue, u = this.unmaskedValue !== t || this.value !== e;
    this._unmaskedValue = t, this._value = e, this.el.value !== s && (this.el.value = s), u && this._fireChangeEvents();
  }
  /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */
  updateOptions(t) {
    const {
      mask: e
    } = t, s = S(t, q), u = !this.maskEquals(e), n = !x(this.masked, s);
    u && (this.mask = e), n && this.masked.updateOptions(s), (u || n) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(t) {
    t != null && (this.cursorPos = t, this._delayUpdateCursor(t));
  }
  /**
    Delays cursor update to support mobile browsers
    @private
  */
  _delayUpdateCursor(t) {
    this._abortUpdateCursor(), this._changingCursorPos = t, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /**
    Fires custom events
    @protected
  */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /**
    Aborts delayed cursor update
    @private
  */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, h.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(t, e) {
    return this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e), this;
  }
  /** Removes custom event listener */
  off(t, e) {
    if (!this._listeners[t])
      return this;
    if (!e)
      return delete this._listeners[t], this;
    const s = this._listeners[t].indexOf(e);
    return s >= 0 && this._listeners[t].splice(s, 1), this;
  }
  /** Handles view input event */
  _onInput(t) {
    if (this._inputEvent = t, this._abortUpdateCursor(), !this._selection)
      return this.updateValue();
    const e = new N(
      // new state
      this.el.value,
      this.cursorPos,
      // old state
      this.displayValue,
      this._selection
    ), s = this.masked.rawInputValue, u = this.masked.splice(e.startChangePos, e.removed.length, e.inserted, e.removeDirection, {
      input: !0,
      raw: !0
    }).offset, n = s === this.masked.rawInputValue ? e.removeDirection : h.NONE;
    let r = this.masked.nearestInputPos(e.startChangePos + u, n);
    n !== h.NONE && (r = this.masked.nearestInputPos(r, h.NONE)), this.updateControl(), this.updateCursor(r), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(t) {
    t.preventDefault(), t.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(t) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(t) {
    this.alignCursorFriendly();
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
d.InputMask = Y;
var K = /* @__PURE__ */ ((i) => (i.PATTERN = "pattern", i.REGEXP = "regexp", i))(K || {});
export {
  K as I,
  d as a
};
